// src/components/Navbar.js
import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import logo from '../imgs/dishalogo.png';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = () => {
    setMenuOpen(false);
  };
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt="Disha Machinery logo" width={100} height={95} />
      </div>

      {/* icon (mobile) */}
      <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </button>

      {/* main links */}
      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
         <li><Link to="/Home" onClick={handleLinkClick}>Home</Link></li>

        {/* Injection Molding  (hover OR click - both work) */}
        <li className="dropdown">
          <button>New&nbsp;Injection&nbsp;Molding&nbsp;Machine </button>

          {/* 1-level submenu */}
          <ul className="submenu">
            {/* General series */}
            <li className="dropdown">
              <button className='same-colr'>General&nbsp;series </button>

              {/* nested submenu */}
              <ul className="submenu right">
                <li><Link to="/bj-series-standard" onClick={handleLinkClick}>DBJ Series – Standard Injection Molding Machine</Link></li>
                <li><Link to="/kii-series" onClick={handleLinkClick}>DKII Series – High Precision Injection Molding Machine</Link></li>
                <li><Link to="/Dp-seriest" onClick={handleLinkClick}>DP Series – Two-Platen Injection Molding Machine</Link></li>
                <li><Link to="/All-electricinj" onClick={handleLinkClick}>DJE Series – All Electric Injection Molding Machine</Link></li>
                <li><Link to="/Hybrid-injectsrs" onClick={handleLinkClick}>DJEV Series – Hybrid Injection Molding Machine</Link></li>
                <li><Link to="/Rotary-injectionibm" onClick={handleLinkClick}>DIBM-R Series Rotary Injection Blow Molding Machine</Link></li>
              </ul>
            </li>
            {/* Product specialised */}
            <li className="dropdown">
              <button className='same-colr'>Product specialised series </button>
              <ul className="submenu right">
                <li><Link to="/Pet-performinje" onClick={handleLinkClick}>PET Series – PET Preform Injection Molding Machine</Link></li>
                <li><Link to="pvc-fittinginjctinjec" onClick={handleLinkClick}>PVC Series – PVC Fitting Injection Molding Machine</Link></li>
                <li><Link to="KF-Seriesthi" onClick={handleLinkClick}>DKF Series – Thin-Wall Injection Molding Machine</Link></li>
                <li><Link to="KES-eriesmedical" onClick={handleLinkClick}>DKE Series – Medical Instrument Injection Molding Machine</Link></li>
                <li><Link to="BJM-series" onClick={handleLinkClick}>DBJM Series – Two Color Injection Molding Machine</Link></li>
                <li><Link to="FB-seriesplast" onClick={handleLinkClick}>DFB Series – Plastic Crates Injection Molding Machine</Link></li>
                <li><Link to="MP-seriesp" onClick={handleLinkClick}>DMP Series – Phone Cases Injection Molding Machine</Link></li>
                <li><Link to="PB-seriesph" onClick={handleLinkClick}>DPB Series – Plastic Buckets Injection Molding Machine</Link></li>
                <li><Link to="T-seriesbak" onClick={handleLinkClick}>DT Series – Bakelite Injection Molding Machine</Link></li>
                <li><Link to="SI-seriessilicon" onClick={handleLinkClick}>SI Series – Silicone Injection Molding Machine</Link></li>

              </ul>
            </li>
          </ul>
        </li>
        {/* Blow Molding */}
        <li className="dropdown">
          <button >Used&nbsp;Injection&nbsp;Molding&nbsp;Machine </button>
          <ul className="submenu">
            <li><Link to="Eb-seriesextrusion" onClick={handleLinkClick}>EB Series – Extrusion Blow</Link></li>
                        <li><Link to="Eb-seriesextrusion" onClick={handleLinkClick}>Auxilary Equipment</Link></li>

          </ul>
        </li>
        {/* Solutions */}
        <li className="dropdown">
          <button className='same-r'>Solutions</button>
          <ul className="submenu">
            <li><Link to="Plasticbackspray" onClick={handleLinkClick}>Plastic Backpack Sprayer</Link></li>
            <li><Link to="Dishposabl" onClick={handleLinkClick}>Disposable Container</Link></li>
            <li><Link to="Palletinjectonmol" onClick={handleLinkClick}>Pallet Injection Molding Machine</Link></li>
            <li><Link to="Ledbulmachi" onClick={handleLinkClick}>LED Bulb IM</Link></li>
            <li><Link to="Plasticstorbox" onClick={handleLinkClick}>18 L Storage Box</Link></li>
          </ul>
        </li>

        {/* News */}
        <li className="dropdown">
          <button>News </button>
          <ul className="submenu">
            <li className="dropdown">
              <button className='same-colr'>Blog</button>

              {/* nested submenu */}
              <ul className="submenu right">
                <li><Link to="/Cavitypetprefor" onClick={handleLinkClick}>72 Cavity PET Preforms Injection Molding Production Line</Link></li>
                <li><Link to="/Choosepetprefo" onClick={handleLinkClick}>How to Choose PET Preform Injection Molding Machine</Link></li>
                <li><Link to="/Thecommontyp" onClick={handleLinkClick}>The Common Types of PET Preform</Link></li>
                <li><Link to="/Gallonbottleca" onClick={handleLinkClick}>5 Gallon Bottle Caps Injection Molding Production Line</Link></li>
                <li><Link to="/InjePlasticbottlec" onClick={handleLinkClick}>Injection Molding Machines for Plastic Bottle Caps</Link></li>
                <li><Link to="/Chooseplasticb" onClick={handleLinkClick}>How to Choose Plastic Bottle Caps Production Equipment?</Link></li>
                <li><Link to="/Howplasticflipt" onClick={handleLinkClick}>How are Plastic Flip Top Bottle Caps Made?</Link></li>
                <li><Link to="/Plasticbottlehand" onClick={handleLinkClick}>Plastic Bottle Handles Injection Molding Production Line</Link></li>
                <li><Link to="/Startanledbu" onClick={handleLinkClick}>How to Start Up an LED Bulb Injection Molding Production Line?</Link></li>
                <li><Link to="/Commonshapesbul" onClick={handleLinkClick}>The Common and Popular Shapes of LED Bulbs</Link></li>
                <li><Link to="/Mat-erialsledlig" onClick={handleLinkClick}>The Most Popular Materials for LED Light Housings</Link></li>
                <li><Link to="/Rig-htplasticpal" onClick={handleLinkClick}>How To Choosing The Right Plastic Pallet Injection Molding Machine</Link></li>
                <li><Link to="/What-standardspla" onClick={handleLinkClick}>What Are The Standards Size of Plastic Pallets?</Link></li>
                <li><Link to="/Com-montypesplasticpa" onClick={handleLinkClick}>Common Types of Plastic Pallets</Link></li>
                <li><Link to="/Comm-onmanufact" onClick={handleLinkClick}>The Common Types of Plastic Pallet Manufacturing Process</Link></li>
                <li><Link to="/Ad-vantagesps" onClick={handleLinkClick}>What Are The Advantages of Plastic Pallets?</Link></li>
                <li><Link to="/Thi-nwalleddisp" onClick={handleLinkClick}>Thin-walled Disposable Food Box Injection Production Equipment</Link></li>
                <li><Link to="/Mix-edplasticbuc" onClick={handleLinkClick}>Mixed Two-Color Plastic Buckets Injection Molding</Link></li>
                <li><Link to="/Pv-cmaterialpro" onClick={handleLinkClick}>PVC Material Products Injection Molding</Link></li>
                <li><Link to="/Ext-rusionblowmol" onClick={handleLinkClick}>EB10H Extrusion Blow Molding Machine K 2022 Exhibition Model</Link></li>
                <li><Link to="/Mol-dingexhibit" onClick={handleLinkClick}>Injection molding machine PET600-S6 will be unveiled at the K 2022 Exhibition</Link></li>
              </ul>
            </li>
          </ul>
        </li>

        {/* Language */}
        <li className="dropdown">
        <button className=''>Contact</button>
          <ul className="submenu">
            <li><Link to="Contacts" onClick={handleLinkClick}>Whoarewe</Link></li>
          </ul>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
